import intl from "react-intl-universal";
import React, {useCallback} from "react";

import {useAppState} from "@stores/AppStateContext";
import {UnsavedChangesConfirmParams} from "../modal-names";

import {ModalConfirm} from "../../../components/ModalConfirm/ModalConfirm"


import {unsavedChangesManager} from "@stores/UnsavedChangesManager";


export const UnsavedChangesConfirm = (
    {openPageByNameArguments}: UnsavedChangesConfirmParams
) => {
    const appState = useAppState();
    const rootStore = appState.rootStore;

    const exitWithoutSave = () => {
        unsavedChangesManager.clearAndLeave();
        // @ts-ignore
        rootStore.view.openPageByName(...openPageByNameArguments)
        handleClose()
    }

    const exitWithSave = async () => {
        unsavedChangesManager.saveAndLeave();
        // @ts-ignore
        rootStore.view.openPageByName(...openPageByNameArguments)
        handleClose()
    }

    const handleClose = useCallback(() => {
        appState.setModal(null);
        appState.setContextMenu(null);
    }, []);

    return (
            <ModalConfirm
                open={true}
                type={'warning'}
                header={intl.get('unsavedEditChangesConfirm.title').d('Wait, Your Changes Haven t Been Saved!')}
                maxWidth={640}
                onClose={handleClose}
                onCancel={exitWithoutSave}
                confirmText={intl.get('unsavedEditChangesConfirm.save_and_leave').d('Save and Exit')}
                onConfirm={exitWithSave}
                cancelText={intl.get('unsavedEditChangesConfirm.discard_and_leave').d('Exit Without Saving')}
            >
                <div>
                    {intl.get('unsavedEditChangesConfirm.Modal.Text.firstPart').d("It looks like you've made some changes to your test that haven't been saved yet.")} &thinsp;
                    <span className='body-large-bold'>
                          {intl.get('unsavedEditChangesConfirm.Modal.Text.boldPart').d("If you leave now, you'll lose all unsaved progress.")}
                    </span>
                </div>
                <br></br>
                {intl.get('unsavedEditChangesConfirm.Modal.Text.secondPart').d('Would you like to save your changes before exiting?')}
            </ModalConfirm>
    );
};

